/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { HIDE_SPINNER, SHOW_SPINNER } from './spinner.types';

export const showSpinnerAction = (spinnerMessage: string, errorCodes?: string): AnyAction => ({
    type: SHOW_SPINNER,
    payload: { isSpinnerActive: true, spinnerMessage, errorCodes },
});

export const hideSpinnerAction = (): AnyAction => ({
    type: HIDE_SPINNER,
    payload: { isSpinnerActive: false, spinnerMessage: '', errorCodes: '' },
});
